<template>
  <div>
    <form @submit.prevent="createCustomerLevel">
      <modal
        v-show="isCustomerLevelModal"
        @close="closeCustomerLevelModal"
        footer
      >
        <template v-slot:title>
          <h5>Update Customer Level</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="title">Title</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="customerLevel.name"
            />
          </div>
          <!-- <div class="form-group">
            <label for="status">Status</label> <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="customerLevel.status"
            >
              <option value="active" class="mb-2">Active</option>
              <option value="in-active" class="mb-2">
                Inactive
              </option>
            </select>
          </div> -->
          <div class="form-group">
            <label for="itslt">Inter Transfer Sending Limit Transaction</label>
            <input
              type="text"
              class="form-control"
              name="itslt"
              v-model="
                customerLevel.inter_transfer_sending_limit_per_transaction
              "
            />
          </div>
          <div class="form-group">
            <label for="itrlt"
              >Inter_Transfer Receiving Limit Transaction</label
            >
            <input
              type="text"
              class="form-control"
              name="itrlt"
              v-model="customerLevel.inter_transfer_receiving_limit_transaction"
            />
          </div>
          <div class="form-group">
            <label for="itdl">Inter Transfer Daily Limit</label>
            <input
              type="text"
              class="form-control"
              name="itdl"
              v-model="customerLevel.inter_transfer_daily_limit"
            />
          </div>
          <div class="form-group">
            <label for="itslpt"
              >Intra Transfer Sending Limit Per Transaction</label
            >
            <input
              type="text"
              class="form-control"
              name="itslpt"
              v-model="
                customerLevel.intra_transfer_sending_limit_per_transaction
              "
            />
          </div>
          <div class="form-group">
            <label for="itrlt"
              >Intra Transfer Receiving Limit Transaction</label
            >
            <input
              type="text"
              class="form-control"
              name="itrlt"
              v-model="customerLevel.intra_transfer_receiving_limit_transaction"
            />
          </div>
          <div class="form-group">
            <label for="itdl">Intra Transfer Daily Limit</label>
            <input
              type="text"
              class="form-control"
              name="itdl"
              v-model="customerLevel.intra_transfer_daily_limit"
            />
          </div>
          <div class="form-group">
            <label for="adl">Airtime Daily Limit</label>
            <input
              type="text"
              class="form-control"
              name="adl"
              v-model="customerLevel.airtime_daily_limit"
            />
          </div>
          <div class="form-group">
            <label for="bdl">Bills Daily Limit</label>
            <input
              type="text"
              class="form-control"
              name="bdl"
              v-model="customerLevel.bills_daily_limit"
            />
          </div>
          <div class="form-group">
            <label for="alpt">Airtime Limit Per Transaction</label>
            <input
              type="text"
              class="form-control"
              name="alpt"
              v-model="customerLevel.airtime_limit_per_transaction"
            />
          </div>
          <div class="form-group">
            <label for="lpt">Limit Per Transaction</label>
            <input
              type="text"
              class="form-control"
              name="lpt"
              v-model="customerLevel.limit_per_transaction"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button
            v-if="permissions.includes('create-kyc-level')"
            type="submit"
            class="button"
            :disabled="creatingCustomerLevelLoading || !formIsValid"
          >
            <span class="custom-loader" v-if="creatingCustomerLevelLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Updating Customer Level...</span
              >
            </span>
            <span v-else>
              Update Customer Level
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeCustomerLevelModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <loader-ring
      v-if="getCustomerLevelLoading"
      class="loader-center"
    ></loader-ring>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Cutomer Levels</h1>
        </div>
        <div class="col-auto">
          <button
            v-if="permissions.includes('create-kyc-level')"
            class="button button--outline text-uppercase"
            @click="showCustomerLevelModal"
          >
            Add Customer Level
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Customer Levels</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="customerLevels"
              :fields="fields"
              :items-per-page="small ? 10 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #updated_at="{item}">
                <td class="table--action-mobile">
                  {{ item.updated_at | date }}
                </td>
              </template>
              <template #action="{item}">
                <td
                  class="table--action-mobile"
                  v-if="permissions.includes('view-kyc-level')"
                >
                  <!-- <router-link class="button" :to="{name: 'Remittance Plan', params: {slug: item.id}}">
                                        View
                                    </router-link> -->
                  <button
                    class="button btn-sucess"
                    @click="showUpdateModal(item)"
                    style="background-color: #0bc681;"
                  >
                    Update
                  </button>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const fields = ["name", "action"];
export default {
  name: "CustomerLevel",
  components: {
    CDataTable
  },
  data() {
    return {
      currentDate: Date.now(),
      fields,
      small: false,

      getCustomerLevelLoading: false,
      isCustomerLevelModal: false,
      creatingCustomerLevelLoading: false,
      customerLevels: [],
      customerLevel: {
        // group: "",
        // body: "",
        // delivery_time: new Date(),
        // title: ""
      }
    };
  },
  computed: {
    formIsValid() {
      return (
        this.customerLevel.inter_transfer_sending_limit_per_transaction !==
          "" &&
        this.customerLevel.inter_transfer_receiving_limit_transaction !== "" &&
        this.customerLevel.inter_transfer_daily_limit !== "" &&
        this.customerLevel.intra_transfer_sending_limit_per_transaction !==
          "" &&
        this.customerLevel.intra_transfer_receiving_limit_transaction !== "" &&
        this.customerLevel.intra_transfer_daily_limit !== "" &&
        this.customerLevel.airtime_daily_limit !== "" &&
        this.customerLevel.bills_daily_limit !== "" &&
        this.customerLevel.airtime_limit_per_transaction !== "" &&
        this.customerLevel.limit_per_transaction !== "" &&
        this.customerLevel.name !== ""
      );
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    showUpdateModal(item) {
      this.customerLevel = Object.assign({}, item);
      this.showCustomerLevelModal();
      console.log(this.customerLevel);
    },
    closeCustomerLevelModal() {
      this.isCustomerLevelModal = false;
      this.customerLevel = {};
    },
    showCustomerLevelModal() {
      this.isCustomerLevelModal = true;
    },
    async getCustomerLevels() {
      try {
        this.getCustomerLevelLoading = true;
        const response = await ApiService.get("settings/kyc-levels");
        this.customerLevels = response.data.data;
        this.getCustomerLevelLoading = false;
      } catch (error) {
        this.getCustomerLevelLoading = false;
        console.log(error.response);
      }
    },
    async createCustomerLevel() {
      try {
        this.creatingCustomerLevelLoading = true;
        const response = await ApiService.post(
          "settings/create-update-kyc-level",
          this.customerLevel
        );

        this.creatingCustomerLevelLoading = false;
        this.closeCustomerLevelModal();
        this.getCustomerLevels();

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
      } catch (error) {
        this.creatingCustomerLevelLoading = false;
        this.closeCustomerLevelModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    }
  },
  mounted() {
    this.getCustomerLevels();
  }
};
</script>

<style scoped></style>
